import { Avatar, Menu } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useCurrentUser } from "../../hooks/currentUser";

export const UserSettings = () => {
  const { currentUser, logoutUser } = useCurrentUser();

  const { activeCharacter } = currentUser;

  const getInitials = () => {
    if (currentUser.givenName && currentUser.familyName) {
      return `${currentUser.givenName[0]}${currentUser.familyName[0]}`;
    }
    return "";
  };

  return (
    <>
      {currentUser.isAuth && (
        <Menu shadow="md">
          <Menu.Target data-testid="user-avatar-button">
            <Avatar
              src={
                activeCharacter
                  ? `/character-images/${activeCharacter.characterId}-token.png`
                  : null
              }
              alt={currentUser.email}
              color="indigo"
            >
              {getInitials()}
            </Avatar>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Label>Manage Your Account</Menu.Label>
            <Menu.Item component="a" href="/settings/profile">
              Profile
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item component="a" onClick={logoutUser}>
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      )}
    </>
  );
};
